import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Footer from '../../../../../components/Footer/Footer';
import InnerNav from '../../../../../components/InnerNav/InnerNav';
import { useFormData } from '../../ContextData/ContextData';

import './Ashtak.scss';

const Ashtak = () => {
  const { userData } = useFormData();
  const [ashtaData, setAshtaData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const canvasRef = useRef(null);
  const [bindus, setBindus] = useState([]);
  const [ascSign, setAscSign] = useState(1); // fallback Asc = Aries

  // Coordinates of houses inside diamond (same as Chart.jsx)
  const houseSlots = {
    1: [100, 350],
    2: [310, 360],
    3: [360, 300],
    4: [370, 90],
    5: [300, 40],
    6: [90, 30],
    7: [40, 100],
    8: [30, 310],
    9: [150, 200],
    10: [200, 270],
    11: [270, 200],
    12: [200, 130],
  };

  useEffect(() => {
    const fetchAshta = async () => {
      try {
        const response = await axios.get(
          'https://core-c343.onrender.com/api/sarvashtakavarga',
          {
            params: {
              year: userData.year,
              month: userData.month,
              day: userData.day,
              hour: userData.hour,
              minute: userData.minute,
            },
          }
        );
        const data = response.data.sarvashtakavarga;
        setAshtaData(data || null);

        // Total row → bindus for chart
        const totalBindus = data.grid.find((g) => g.planet === 'Total').bindus;
        setBindus(totalBindus);

        // Default Ascendant = Aries
        setAscSign(1);
      } catch (err) {
        setError(err.message || 'Error fetching Sarvashtakavarga');
      } finally {
        setLoading(false);
      }
    };

    fetchAshta();
  }, [userData]);

  // Rotate houses based on ascendant sign
  const getRotatedSign = (houseIdx) => {
    if (!ascSign) return houseIdx;
    return ((ascSign - 1 + (houseIdx - 1)) % 12) + 1;
  };

  // Color mapping based on bindu values
  const getDotColor = (binduValue) => {
    if (binduValue >= 4) return 'orange';      // strong/auspicious
    if (binduValue === 3) return 'seagreen';   // medium
    if (binduValue === 2) return 'dodgerblue'; // weaker
    return 'grey';                             // low
  };

  // Draw chart
  useEffect(() => {
    if (!canvasRef.current || bindus.length === 0) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Outer diamond
    ctx.beginPath();
    ctx.moveTo(200, 0);
    ctx.lineTo(400, 200);
    ctx.lineTo(200, 400);
    ctx.lineTo(0, 200);
    ctx.closePath();
    ctx.strokeStyle = '#FF8C42';
    ctx.lineWidth = 2;
    ctx.stroke();

    // Cross diagonals
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(400, 400);
    ctx.moveTo(400, 0);
    ctx.lineTo(0, 400);
    ctx.stroke();

    // Draw bindus as circles
    Object.keys(houseSlots).forEach((houseIdx) => {
      const realSign = getRotatedSign(parseInt(houseIdx));
      const binduValue = bindus[realSign - 1];
      const [x, y] = houseSlots[houseIdx];

      // Circle
      ctx.beginPath();
      ctx.arc(x, y, 20, 0, 2 * Math.PI);
      ctx.fillStyle = getDotColor(binduValue);
      ctx.fill();

      // Number inside circle
      ctx.fillStyle = 'white';
      ctx.font = 'bold 14px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(binduValue, x, y);

      // House number
      ctx.fillStyle = 'black';
      ctx.font = '12px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'top';
      const rotatedHouseNum = getRotatedSign(parseInt(houseIdx));
      ctx.fillText(rotatedHouseNum, x, y + 25);
    });
  }, [bindus, ascSign]);

  if (loading) return <p className="loading-text">Loading...</p>;
  if (error) return <p className="error-text">{error}</p>;
  if (!ashtaData) return <p>No data available</p>;

  const headers = ashtaData.signs || [];

  return (
    <div className="ashta-container">
      <InnerNav />
      <div className="ashta-section">
        <h2>Ashtakvarga - Sarvashtakavarga</h2>

        {/* Table */}
        <table className="ashta-table">
          <thead>
            <tr>
              <th>Planet</th>
              {headers.map((head, i) => (
                <th key={i}>{head}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ashtaData.grid.map((row, i) => (
              <tr key={i}>
                <td className="planet-name">{row.planet}</td>
                {row.bindus.map((bindu, j) => (
                  <td key={j}>{bindu}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        {/* Chart */}
        <div className="chart-wrapper" style={{ marginTop: '2rem', textAlign: 'right' }}>
          <div className="asthak-chart">
          <h2>Indicator</h2>
          <p style={{ color:  'dodgerblue'}}>Auspicious Sign</p>
          <p style={{ color: 'orange' }}>Inauspicious Sign</p>
          <p style={{ color: 'seagreen' }}>Mixed Sign</p>
          <p style={{ color: 'grey' }}>Neutral Sign</p>
          <h2>Significance</h2>
          <p style={{ color: 'orange' }}>Father</p>
          <p style={{ color: 'green' }}>Government</p>
        </div>
          <canvas
            ref={canvasRef}
            width={400}
            height={400}
            style={{ border: '1px solid black' }}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Ashtak;
